<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix">
      <div id="main_area">
        <div style="clear: both"></div>
        <div class="information">
          <h3>S301使用者帳號維護</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tbody>
                <tr>
                  <td>姓名：</td>
                  <td><input type="text" v-model="form.name" /></td>
                  <td>身分證統一編號：</td>
                  <td>
                    <input type="text" v-model="form.idn" />
                  </td>
                </tr>
                <tr>
                  <td>職稱：</td>
                  <td><input type="text" v-model="form.title" /></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>聯絡電話：</td>
                  <td>
                    <input type="text" v-model="form.tel" />
                  </td>
                  <td>E-Mail：</td>
                  <td>
                    <input
                      type="text"
                      class="input"
                      title="請輸入有效且能正常收信之EMAIL"
                      Placeholder="請確認為有效且能正常收信之EMAIL"
                      v-model="form.email"
                      size="40"
                      maxlength="40"
                    />
                  </td>
                </tr>
                <tr>
                  <td>到職日期：</td>
                  <td>
                    <DatePicker
                      v-model="form.arrive_date"
                      format="YYYMMDD"
                      :isTaiwanYear="true"
                      clearable
                      placeholder="請輸入/選擇日期"
                    /><br />
                  </td>
                  <td>現職狀況：</td>
                  <td>
                    <select disabled="disabled" v-model="form.now_st">
                      <option value="1">在職</option>
                      <option value="2">離職</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td style="width: 150px">備註：</td>
                  <td colspan="3">
                    <p>
                      <textarea
                        title="最多輸入5百個字"
                        Placeholder="最多輸入5百個字"
                        cols="100"
                        rows="5"
                        v-model="form.note"
                      ></textarea>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td colspan="4" class="f_center">
                    <label for="checkbox"
                      ><span>
                        <input
                          type="submit"
                          class="btn"
                          value="存檔"
                          @click="btnSave()"
                        /> </span
                    ></label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="f_center"></div>
        </div>
      </div>
      <!-- 頁籤結束 -->
    </div>
    <CyFooter />

    <Alert v-model="Alert.show" :title="Alert.title" :ServiceUnit="pageData.ServiceUnit">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import VueDatepicker from "@/components/Common/VueDatepickerLocal";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import { getMenuIndex } from "@/config/util.js";
import { S301_Query, S301_Modify } from "@/service/api.js";
import CyFooter from "@/components/Common/CyFooter.vue";
export default {
  name: "S301",
  data: function () {
    return {
      pageData: {
        MenuIndex: 3,
        PrgName: "S301",
        ServiceUnit: "CY",
        isForceLoginOut: true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      form: {
        idn: "",
        name: "",
        title: "",
        rank: "",
        tel: "",
        email: "",
        arrive_date: "",
        now_st: "",
        note: "",
        jobstatus: "",
      },
      dropDownList: {
        govCode1s: [],
        govCode2s: [],
        govCode3s: [],
        govCode4s: [],
      },
      Alert: {
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.show = false;
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    Alert: VueModal,
    CyFooter,
    DatePicker: VueDatepicker,
  },
  methods: {
    //查詢
    doQuery: function () {
      const self = this;
      let postData = {
        ServiceUnit : self.pageData.ServiceUnit,
        ID: self.loginInfo.id,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      S301_Query(postData).then((rData) => {
        self.form.idn = rData.returnObject.idn;
        self.form.name = rData.returnObject.name;
        self.form.title = rData.returnObject.title;
        self.form.rank = rData.returnObject.rank;
        self.form.tel = rData.returnObject.tel;
        self.form.email = rData.returnObject.email;
        self.form.arrive_date = rData.returnObject.arrivE_DATE ? self.$moment(rData.returnObject.arrivE_DATE)._d : "";
        self.form.now_st = rData.returnObject.noW_ST;
        self.form.note = rData.returnObject.note;
      });
    },
    //存檔
    btnSave: function () {
      const self = this;
      let postData = {
        ServiceUnit : self.pageData.ServiceUnit,
        ID: self.loginInfo.id,
        NAME: self.form.name,
        IDN: self.form.idn,
        TITLE: self.form.title,
        TEL: self.form.tel,
        EMAIL: self.form.email,
        ARRIVE_DATE: self.form.arrive_date ? self.form.arrive_date : null,
        NOTE: self.form.note,
        NOW_ST: self.form.now_st,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "存檔",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      S301_Modify(postData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["存檔成功"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.form.Selected = [];
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["存檔失敗"];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
  },
  created() {
    const self = this;
    //RoleAuthorizeMenu
    self.pageData.MenuIndex = getMenuIndex(self.pageData.PrgName);
    if (self.pageData.MenuIndex === null) {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    self.doQuery();
  },
};
</script>

<style scoped src="@/assets/css/Cy.css" />
